import { ReactNode } from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { theme, GlobalStyles } from '@shared/styles';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <SCThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </SCThemeProvider>
);
